<template>
  <div class="content animate-route">
    <banner bgColor="#d2d2d2" :title="title" :navShow="!keyword">
      <img src="@/assets/images/banner.jpg" slot="image" style="width: 100%" />
      <div class="nav" slot="nav">
        <div class="list" v-for="(item, index) in productType" :key="index">
          <span class="title" :class="item.value === currentId ? 'active' : null" @click="changeType(item.value)">{{
            item.title
          }}</span>
        </div>
      </div>
    </banner>
    <a-row class="customer" type="flex">
      <a-col :span="24" v-if="keyword">
        <div class="keywordCount">为您搜索到结果 {{ total }} 条</div>
      </a-col>
      <a-col
        class="animate-route"
        :sm="6"
        :xs="24"
        @click="onDetails(item.id)"
        v-for="item in productList"
        :key="item.id"
      >
        <div class="wrap border-1px">
          <div class="top">
            <span class="tag title">{{ item.name }}</span>
          </div>
          <div class="middle border-1px">
            <div id="mask" class="mask"></div>
            <img :src="imgUrl + item.productImg" width="260" height="170" alt="" />
          </div>
          <div class="bottom">
            <span class="name title">
              <ellipsis :length="102" tooltip>{{ item.content }}</ellipsis>
            </span>
          </div>
          <a-row class="more" type="flex" justify="center" align="middle">
            <a-col :span="2"><right-square theme="filled" size="14" :strokeWidth="3" class="title icon" /></a-col>
            <a-col :span="5"><span class="detail title">查看详情</span></a-col>
          </a-row>
        </div>
      </a-col>
    </a-row>
    <a-row class="load">
      <a-col v-if="productList.length > 0" :span="24">
        <span class="link" v-if="total === productList.length">已经到底了~</span>
        <a-button v-else type="link" size="large" class="link" @click="nextPage">点击查看更多</a-button>
      </a-col>
      <!-- <a-empty class="nodata" v-else description="暂无数据"></a-empty> -->
    </a-row>
  </div>
</template>
<script>
import { RightSquare } from '@icon-park/vue'
import { getDictByCode, getProductList } from '@/api'
import Banner from '@/components/Banner'
import Ellipsis from '@/components/Ellipsis'
export default {
  name: 'Customer',
  components: {
    Banner,
    RightSquare,
    Ellipsis,
  },
  data() {
    return {
      title: {
        eng: 'PRODUCTS',
        chs: '产品展示',
      },
      productType: [],
      currentId: '1',
      productList: [],
      total: null,
      keyword: null,
      imgUrl: process.env.VUE_APP_IMG_URL,
      page: {
        pageNo: 1,
        pageSize: 16,
      },
    }
  },
  created() {
    this.keyword = this.$route.query.keyword
    this.initData()
  },
  methods: {
    initData() {
      getDictByCode('product_type').then((res) => {
        if (res.success) {
          this.productType = res.result
        }
      })
      this.getProductData(this.currentId)
    },
    getProductData(productType) {
      let param = { ...this.page, type: productType }
      if (this.keyword) {
        param = { ...this.page, name: this.keyword }
      }
      getProductList(param).then((res) => {
        if (res.success) {
          this.productList = this.productList.concat(res.result.records).map((el) => {
            return {
              ...el,
              content: el.content
                .replace(/<\/?.+?>/g, '')
                .replace(/[\r\n]/g, '')
                .replace(`&nbsp;`, ''),
            }
          })
          this.total = res.result.total
        }
      })
    },
    nextPage() {
      this.page.pageNo += 1
      this.getProductData(this.currentId)
    },
    onDetails(id) {
      const link = this.$router.resolve({ path: '/main/productdetails', query: { id } })
      window.open(link.href, '_blank')
    },
    changeType(id = '1') {
      this.currentId = id
      this.page.pageNo = 1
      this.productList = []
      this.getProductData(id)
    },
  },
}
</script>
<style lang="stylus" scoped>
@import './index'
route()
.content
  .nav
    menu()
  .order
    width 100%
    margin-top 40px
    .title1
      font-size 16px
      color #000
      opacity 0.5
  .customer
    margin 0 auto
    max-width 1340px
    padding 40px 0 20px 0
    .keywordCount
      margin-bottom 24px
      font-weight bold
      font-size: 16px
    .border-1px
      border 1px rgba(0, 0, 0, 0.2) solid
    .title
      color #666
    .wrap
      width 300px
      margin 0 auto 40px auto
      &:hover, &:hover > .border-1px
        border 1px rgba(0, 0, 0, 1) solid
        cursor pointer
      &:hover .title
        color #000
      &:hover #mask
        opacity 0.5
      .top
        margin-top 25px
        .tag
          font-size 16px
      .middle
        margin 20px 17px
        position relative
        .mask
          position absolute
          width 100%
          height 100%
          top 0
          left 0
          background-color #000
          opacity 0
        img
          position relative
          width 100%
          height 100%
          top 0
          left 0
      .bottom
        padding 0 20px
        height 60px
        text-align left
        .name
          font-size 14px
      .more
        position relative
        margin 25px 0
        line-height 14px
        .icon
          position relative
          top 1px
          left 5px
        .detail
          font-size 14px
  .load
    margin-bottom 60px
    .link
      color #666
      font-size 24px
</style>
